import ModalCustom from '../../UI/modal';
import AddTripForm from '../../forms/add-trip-form';

type Props = {
  show: boolean;
  handleClose: () => void;
};
const AddTripModal = ({ show, handleClose }: Props) => {
  return (
    <ModalCustom
      show={show}
      onHide={handleClose}
      title='Add Trip'
      paddingBody='30px 32px 32px'
    >
      <AddTripForm
        label='Trip Name'
        placeholder='Enter trip name'
        submitTitle='Add Trip'
        onSuccess={handleClose}
      />
    </ModalCustom>
  );
};
export default AddTripModal;
